import styles from "./FileInput.module.css";
import React, { type CSSProperties } from "react";
import type FileInputProperties from "./FileInput.properties.ts";

export default function FileInputView(props: FileInputProperties) {
  return (
    <label
      className={styles.uploadButton}
      style={{ "--width": props.width ?? 160 } as CSSProperties}
    >
      {props.label}
      <input
        className={styles.hiddenInput}
        onChange={props.onChange}
        type="file"
        accept=".jpg,.jpeg,image/jpeg"
      />
    </label>
  );
}
